import { Link } from "react-router-dom";

const KategoriBox = (props) => {
  const { id, nama, gambar, size = "small" } = props;

  let width, height;

  switch (size) {
    case "small":
      width = "w-[10.4rem]";
      height = "h-[calc(4/5*10.4rem)]";
      break;
    case "medium":
      width = "w-[12rem]";
      height = "h-[6.75rem]";
      break;
    case "large":
      width = "w-full";
      height = "h-[8.4375rem]";
      break;
    default:
      width = "w-[9rem]";
      height = "h-[5.0625rem]";
      break;
  }

  return (
    <div className="col-start-start">
      <Link className="col-start-start gap-1 w-full" to={`/kategori/${id}`}>
        <div className={`${width} ${height} bg-stone-100 rounded-md`}>
          <img
            className="w-full h-full object-cover rounded-md"
            src={gambar ? gambar : "/no-image-small.jpg"}
          />
        </div>
        <span className="font-semibold text-slate-700">{nama}</span>
      </Link>
    </div>
  );
};

export default KategoriBox;
